import { SectionWrapper } from './SectionWrapper';

interface Recommendation {
  name: string;
  quote: string;
}

interface RecommendationsProps {
  recommendations: Recommendation[];
  /** Label text before the LinkedIn link */
  prefixText?: string;
  /** LinkedIn link text */
  linkText?: string;
}

const LINKEDIN_URL = 'https://www.linkedin.com/in/valto/details/recommendations/';

export function Recommendations({
  recommendations,
  prefixText = 'Highlights from public recommendations.',
  linkText = 'View all received recommendations on LinkedIn.',
}: RecommendationsProps) {
  return (
    <SectionWrapper>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {recommendations.map((rec) => (
          <div key={rec.name} className="flex flex-col">
            <blockquote className="text-slate-600 leading-relaxed mb-4 italic">
              "{rec.quote}"
            </blockquote>
            <p className="text-slate-900 font-medium mt-auto">{rec.name}</p>
          </div>
        ))}
      </div>
      <p className="text-sm text-slate-400 text-center mt-10">
        {prefixText}{' '}
        <a
          href={LINKEDIN_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-slate-600 transition-colors"
        >
          {linkText}
        </a>
      </p>
    </SectionWrapper>
  );
}

// ── Pre-defined recommendation sets ──

export const coachRecommendations: Recommendation[] = [
  {
    name: 'Mika Valtasaari',
    quote: 'Valto is the Bugatti Veyron of coaches. He gets you to where you need to be faster then you ever imagined.',
  },
  {
    name: 'Edvard Sandblom',
    quote: 'Valto gave us several priceless tips on how to prepare, set up and run a business without making stupid mistakes.',
  },
  {
    name: 'Paul Klunko',
    quote: 'Valto has extensive experience in all stages of starting a new business… Valto has provided… valuable advice on how to approach our clients and position our service offering.',
  },
];

export const workshopRecommendations: Recommendation[] = [
  {
    name: 'Jeremy Laurin',
    quote: 'Valto and his team led a group of senior executives through a two day workshop… of enormous value.',
  },
  {
    name: 'Liisa Paavilainen',
    quote: "Valto's wide experience and deep knowledge in entrepreneurship has been vital for us… ability also to combine strategic thinking with pragmatic approach for getting things started.",
  },
  {
    name: 'Claes Mikko Nilsen',
    quote: 'Valto makes things happen and keeps things going on… good ideas are put directly in action.',
  },
];

export const trainingRecommendations: Recommendation[] = [
  {
    name: 'Fakhri Aslan',
    quote: 'My UX & UI design skills have greatly improved as a result of his thoughtful guidance.',
  },
  {
    name: 'Ana-Belén Abundio Femenía',
    quote: 'Working with Valto is learning constantly… working side by side with him… has provided me more knowledge in entrepreneurship than 10 years of studies.',
  },
  {
    name: 'Mika Valtasaari',
    quote: 'Inside of a month, I had the ability and confidence to pitch what EnterpriseHelsinki NewCo Factory does to an international audience.',
  },
];

export const advisoryRecommendations: Recommendation[] = [
  {
    name: 'Ajit Jaokar',
    quote: 'I found him a strategic thinker but also very pragmatic in his approach.',
  },
  {
    name: 'Timo Onnela',
    quote: 'Valto has great strategic visions and is able to plan and execute the agreed actions succesfully and manage the contractors.',
  },
  {
    name: 'Katariina Rantanen',
    quote: 'Valto is a dynamic professional, with a knack at simplifying seemingly tricky issues.',
  },
];

export const aboutRecommendations: Recommendation[] = [
  {
    name: 'Liisa Paavilainen',
    quote: 'I have seldom met such a smart, dedicated, sincere person and I admire his ability to lead and motivate people in a way it brings out the best in them.',
  },
  {
    name: 'Daniel de la Cruz',
    quote: "Valto epitomizes the phrase 'thinking outside of the box'… never has he been exhausted of creative solution to any challenge…",
  },
  {
    name: 'Julie Roskowski',
    quote: 'Valto is a visionary, who excels at seeing where the market is going… making him a natural leader.',
  },
];
